import React from "react";
import { NewInterviewShape } from "../interfaces/classTypes";
import { NewInterview } from "./new_interview_class";

var currentMonitorProfile;
export class MonitorProfile {
  public id: number;
  public interviews: NewInterviewShape[];

  constructor(data: any) {
    this.id = data.id;
    this.interviews = data.interviews.map(
      (interview) => new NewInterview(interview) // This method does not seem to be used.
      // It is missing the setId parameter, which is required in NewInterview constructor.
    );
    this.save();
  }
  save() {
    currentMonitorProfile = this;
  }

  static currentProfile() {
    return currentMonitorProfile;
  }
}
